"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var icoFormDown_svg_1 = require("../icons/icoFormDown.svg");
var icoFormUp_svg_1 = require("../icons/icoFormUp.svg");
exports.colors = {
    active: polished_1.rgba(221, 221, 221, 0.5),
    black: '#000000',
    white: '#FFFFFF',
    border: {
        dark: '#60676F',
        light: '#CACDCF'
    },
    shadowInset: '#CACDCF',
    brandOrange: '#F26722',
    brand: {
        dark: '#FFFFFF',
        light: '#0479CD'
    },
    control: {
        dark: '#CACDCF',
        light: '#CACDCF'
    },
    focus: '#00AEEF',
    placeholder: '#9C9A98',
    text: {
        dark: '#FFFFFF',
        light: '#3E3C3B'
    },
    secondaryText: {
        dark: '#FFFFFF',
        light: '#5E5D5C'
    },
    tertiaryText: {
        dark: '#FFFFFF',
        light: '#757370'
    },
    primaryText: '#3E3C3B',
    accordionText: {
        dark: '#FFFFFF',
        light: '#5E5D5C'
    },
    'primaryBlue-1': '#0479CD',
    'primaryBlue-2': '#0366AE',
    'primaryBlue-3': '#035B9A',
    'secondaryBlue-1': '#00AEEF',
    'secondaryBlue-2': '#EDFAFE',
    'secondaryBlue-3': '#C9EEFC',
    'grey-1': '#F4F5F5',
    'grey-2': '#DFE0E2',
    'grey-3': '#CACDCF',
    'grey-4': '#B4B8BC',
    'grey-5': '#9FA4A9',
    'grey-6': '#898F95',
    'grey-7': '#747B82',
    'grey-8': '#60676F',
    'grey-9': '#4A535C',
    'grey-10': '#353F49',
    'dark-1': '#333333',
    'dark-2': '#363636',
    'dark-3': '#555555',
    'dark-4': '#666666',
    'dark-5': '#777777',
    'dark-6': '#999999',
    'dark-7': '#0A1839',
    'light-1': '#F6F6F6',
    'light-2': '#EEEEEE',
    'light-3': '#DDDDDD',
    'light-4': '#CCCCCC',
    'light-5': '#BBBBBB',
    'light-6': '#AAAAAA',
    'status-critical': '#EB6060',
    'status-error': '#D0021B',
    'status-warning': '#F7E463',
    'status-ok': '#61D125',
    'status-unknown': '#A8A8A8',
    'status-disabled': '#A8A8A8',
    'colour-secondary': '#196CFF',
    'colour-secondary-dark': '#004BCC',
    'colour-black': '#000F20',
    'colour-grey1': '#FAFAFA',
    'colour-grey2': '#EDEEEF',
    'colour-grey3': '#D2D5D8',
    'colour-grey4': '#B9BDC2',
    'colour-grey5': '#9FA6AC',
    'colour-grey6': '#848C94',
    'colour-grey7': '#68727C',
    'colour-grey8': '#404E59',
    'colour-grey9': '#2A3A47'
};
var spacingScale = {
    xsmall: 0.5,
    small: 0.75,
    medium: 1,
    large: 1.5,
    xlarge: 2,
    xxlarge: 2.25,
    huge: 3,
    xhuge: 4
};
// spacing mainly for padding and margin
exports.spacing = function (baseSpacing) {
    if (baseSpacing === void 0) { baseSpacing = 24; }
    // details about spacing: https://isobar.invisionapp.com/share/KSOOZHB8TP2#/screens/326820804
    var defaultThemeSizes = {
        none: '0px',
        xxsmall: '6px' // TODO: not in the design, possible to remove?
    };
    var result = {};
    var spacingKeys = Object.keys(spacingScale);
    spacingKeys.forEach(function (size) {
        result[size] = baseSpacing * (spacingScale[size] || 0) + "px";
    });
    return tslib_1.__assign(tslib_1.__assign({}, defaultThemeSizes), result);
};
exports.generate = function (baseSpacing, scale) {
    if (baseSpacing === void 0) { baseSpacing = 24; }
    if (scale === void 0) { scale = 4; }
    // 24
    var baseFontSize = 16;
    var fontScale = baseSpacing / scale; // 6
    var fontSizing = function (factor) {
        return ({
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        });
    };
    var borderWidth = 2;
    var result = {
        accordion: {
            icons: {
                collapse: "-",
                expand: "+"
                // color: { dark: undefined, light: undefined },
            }
        },
        anchor: {
            textDecoration: 'none',
            fontWeight: 600,
            color: {
                dark: '#6194EB',
                light: '#1D67E3'
            },
            hover: {
                textDecoration: 'underline'
            }
        },
        box: {
            responsiveBreakpoint: 'xs',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)'
        },
        button: {
            text: {
                // fontFamily: 'AvenirLTPro-Heavy', // this is on the design, but it does look more bold than the design
                size: '16px',
                lineHeight: '26px'
            },
            border: {
                width: borderWidth + "px",
                radius: baseSpacing * 0.25 + "px" // 6px
            },
            primary: {
                color: '#FFFFFF',
                backgroundColor: exports.colors['primaryBlue-1'],
                backgroundColorOnHover: exports.colors['primaryBlue-2'],
                backgroundColorOnPressed: exports.colors['primaryBlue-3']
            },
            secondary: {
                color: exports.colors['primaryBlue-1'],
                backgroundColor: '#FFFFFF',
                backgroundColorOnHover: exports.colors['secondaryBlue-2'],
                backgroundColorOnPressed: exports.colors['secondaryBlue-3']
            },
            tertiary: {
                color: exports.colors['primaryBlue-1'],
                backgroundColor: '#FFFFFF',
                backgroundColorOnHover: exports.colors['secondaryBlue-2'],
                backgroundColorOnPressed: exports.colors['secondaryBlue-3']
            },
            disabled: {
                opacity: 0.3
            },
            minWidth: baseSpacing * 4 + "px",
            maxWidth: baseSpacing * 16 + "px",
            padding: {
                vertical: "17px",
                horizontal: baseSpacing - borderWidth + "px"
            }
        },
        buttonV2: {
            text: {
                size: '18px',
                lineHeight: '24px'
            },
            border: {
                width: borderWidth + "px",
                radius: '24px'
            },
            primary: {
                color: '#FFFFFF',
                backgroundColor: exports.colors['colour-secondary'],
                backgroundColorOnHover: exports.colors['colour-secondary-dark'],
                backgroundColorOnPressed: exports.colors['colour-secondary-dark']
            },
            secondary: {
                color: exports.colors['colour-secondary'],
                backgroundColor: '#FFFFFF',
                backgroundColorOnHover: exports.colors['colour-secondary-dark'],
                backgroundColorOnPressed: exports.colors['colour-secondary-dark']
            },
            tertiary: {
                color: exports.colors['colour-secondary'],
                backgroundColor: '#FFFFFF',
                backgroundColorOnHover: '#FFFFFF',
                backgroundColorOnPressed: '#FFFFFF'
            },
            disabled: {
                opacity: 0.3
            },
            minWidth: baseSpacing * 4 + "px",
            maxWidth: baseSpacing * 16 + "px",
            padding: {
                vertical: "12px",
                horizontal: "24px"
            }
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'border'
                },
                width: '1px'
            },
            check: {
                radius: '4px',
                thickness: '2px'
            },
            icon: {
            // size: undefined,
            // extend: undefined,
            },
            icons: {
            // checked: undefined,
            },
            hover: {
                border: {
                    color: {
                        dark: 'focus',
                        light: 'focus'
                    }
                }
            },
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            size: baseSpacing - 2,
            knobSize: baseSpacing,
            toggle: {
                color: {
                    dark: '#d9d9d9',
                    light: '#FFFFFF',
                    checked: '#61D125',
                    unchecked: '#D0021B',
                    disabled: '#DFE0E2'
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 1.75,
                // extend: undefined,
                knob: {
                // extend: undefined,
                }
            }
            // extend: undefined,
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        dataTable: {
            header: {},
            groupHeader: {
                border: { side: 'bottom', size: 'xsmall' },
                fill: 'vertical',
                pad: { horizontal: 'xsmall', vertical: 'xxsmall' },
                background: {
                    dark: 'dark-2',
                    light: 'light-2'
                }
            },
            icons: {
                ascending: icoFormDown_svg_1.ReactComponent,
                contract: icoFormUp_svg_1.ReactComponent,
                descending: icoFormUp_svg_1.ReactComponent,
                expand: icoFormDown_svg_1.ReactComponent
            },
            resize: {
                border: {
                    side: 'right',
                    color: 'border'
                }
            },
            primary: {
                weight: 'bold'
            }
        },
        dropdown: {
            icon: {
                size: baseSpacing / 2 + "px",
                rightPosition: "right " + (baseSpacing - 8) + "px center"
            },
            divider: {
                height: '60%',
                rightPosition: baseSpacing + 14 + "px"
            }
        },
        heading: {
            level: {
                1: {
                    small: { size: '32px', height: '40px' },
                    medium: { size: '38px', height: '46px' },
                    large: { size: '46px', height: '56px' }
                },
                2: {
                    small: { size: '28px', height: '36px' },
                    medium: { size: '32px', height: '38px' },
                    large: { size: '36px', height: '44px' }
                },
                3: {
                    small: { size: '24px', height: '32px' },
                    medium: { size: '26px', height: '34px' },
                    large: { size: '28px', height: '36px' }
                },
                4: {
                    small: { size: '20px', height: '30px' },
                    medium: { size: '22px', height: '34px' },
                    large: { size: '22px', height: '34px' }
                },
                5: {
                    small: { size: '16px', height: '26px' },
                    medium: { size: '16px', height: '26px' },
                    large: { size: '16px', height: '26px' }
                },
                6: {
                    small: { size: '13px', height: '20px' },
                    medium: { size: '13px', height: '20px' },
                    large: { size: '13px', height: '20px' }
                }
            },
            weight: 'normal'
        },
        flexGrid: {
            // maxWidth = content width + 2 * gutter width
            maxWidth: 1440,
            breakpoints: {
                xs: {
                    gutter: 24,
                    outsideGutter: 28
                },
                sm: {
                    gutter: 24,
                    outsideGutter: 36
                },
                md: {
                    gutter: 32,
                    outsideGutter: 64
                },
                lg: {
                    gutter: 32,
                    outsideGutter: 64
                }
            }
        },
        global: {
            animation: {
                duration: '1s',
                durationMS: 1000,
                jiggle: {
                    duration: '0.1s',
                    durationMS: 100
                }
            },
            transition: {
                duration: '0.3s',
                durationMS: 300
            },
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                large: baseSpacing / 2 + "px",
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                xs: {
                    minValue: 0,
                    maxValue: 767,
                    edgeSize: exports.spacing(24),
                    edgeSizeHorizontal: exports.spacing(16),
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        large: baseSpacing / 4 + "px",
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    size: {
                        xxsmall: baseSpacing + "px",
                        xsmall: baseSpacing * 2 + "px",
                        small: baseSpacing * 4 + "px",
                        medium: baseSpacing * 8 + "px",
                        large: baseSpacing * 16 + "px",
                        xlarge: baseSpacing * 32 + "px",
                        full: '100%'
                    }
                },
                sm: {
                    minValue: 768,
                    maxValue: 1023,
                    edgeSize: exports.spacing(24),
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        large: baseSpacing / 4 + "px",
                        xlarge: baseSpacing / 2 + "px" // 12
                    }
                },
                md: {
                    minValue: 1024,
                    maxValue: 1439,
                    edgeSize: exports.spacing(32)
                },
                lg: {
                    minValue: 1440,
                    maxValue: null,
                    edgeSize: exports.spacing(32)
                }
            },
            colors: exports.colors,
            control: {
                border: {
                    width: '1px',
                    radius: '4px',
                    color: 'border'
                }
            },
            drop: {
                background: '#FFFFFF',
                border: {
                    width: '0px',
                    radius: '0px'
                },
                shadowSize: 'small',
                maxHeight: '360px'
            },
            edgeSize: tslib_1.__assign(tslib_1.__assign({}, exports.spacing(24)), { responsiveBreakpoint: 'xs' }),
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                border: {
                    color: 'focus'
                }
            },
            font: tslib_1.__assign({}, fontSizing(0)),
            hover: {
                background: {
                    dark: {
                        color: 'active',
                        opacity: 'medium'
                    },
                    light: {
                        color: 'active',
                        opacity: 'medium'
                    }
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    vertical: '15px',
                    horizontal: '15px'
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                xsmall: baseSpacing * 4 + "px",
                small: baseSpacing * 8 + "px",
                medium: baseSpacing * 16 + "px",
                large: baseSpacing * 32 + "px",
                xlarge: baseSpacing * 48 + "px",
                xxlarge: baseSpacing * 64 + "px",
                full: '100%'
            }
        },
        icon: {
            colors: exports.colors
        },
        iconThemes: {},
        input: {
            fontFamily: {
                label: 'AvenirLTPro-Heavy',
                error: 'AvenirLTPro-Roman'
            }
        },
        layer: {
            background: 'white',
            border: {
                radius: '4px'
            },
            container: {
                zIndex: '15'
            },
            overlay: {
                background: 'rgba(0, 0, 0, 0.2)'
            },
            responsiveBreakpoint: 'xs',
            zIndex: '10'
        },
        paragraph: {
            small: tslib_1.__assign({}, fontSizing(-0.5)),
            medium: tslib_1.__assign({}, fontSizing(0)),
            large: tslib_1.__assign({}, fontSizing(1)),
            xlarge: tslib_1.__assign({}, fontSizing(2)),
            xxlarge: tslib_1.__assign({}, fontSizing(4))
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'border'
                },
                width: '1px'
            },
            check: {
                radius: '100%'
            },
            hover: {
                border: {
                    color: {
                        dark: 'focus',
                        light: 'focus'
                    }
                }
            },
            icon: {
            // size: undefined,
            // extend: undefined,
            },
            icons: {
            // circle: undefined,
            },
            gap: 'xsmall',
            size: baseSpacing - 4 + "px"
        },
        select: {
            // background: undefined,
            container: {
            // extend: undefined,
            },
            control: {
            // extend: undefined,
            },
            // searchInput: undefined,
            step: 20
        },
        tab: {
            active: {
                color: 'text'
                // background: undefined,
            },
            background: '#d0d3d5',
            divider: exports.colors.white,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // extend: undefined,
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        table: {
            header: {
                align: 'start',
                pad: { horizontal: 'xsmall', vertical: 'xxsmall' },
                border: {
                    color: {
                        dark: 'rgba(255, 255, 255, 0.5)',
                        light: 'border'
                    },
                    width: '1px'
                },
                verticalAlign: 'bottom',
                fill: 'vertical',
                background: {
                    color: '#F6FCFE'
                }
                // extend: undefined,
            },
            body: {
                align: 'start',
                pad: { horizontal: 'xsmall', vertical: 'xxsmall' },
                border: { side: 'all' }
                // extend: undefined,
            },
            footer: {
                align: 'start',
                pad: { horizontal: 'xsmall', vertical: 'xxsmall' },
                border: 'top',
                verticalAlign: 'top',
                fill: 'vertical'
                // extend: undefined,
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            header: {
            // background: undefined,
            // extend: undefined,
            },
            panel: {
            // extend: undefined,
            }
            // gap: undefined,
        },
        text: {
            xsmall: { size: '11px', lineHeight: '15px', fontFamily: 'AvenirLTPro-Heavy' },
            small: { size: '13px', lineHeight: '20px', fontFamily: 'AvenirLTPro-Roman' },
            medium: { size: '16px', lineHeight: '26px', fontFamily: 'AvenirLTPro-Roman' },
            large: {
                size: '22px',
                lineHeight: '34px',
                fontFamily: 'AvenirLTPro-Light',
                breakpoints: {
                    xs: {
                        size: '20px',
                        height: '30px'
                    }
                }
            }
        }
    };
    return result;
};
exports.base = exports.generate(24);
//# sourceMappingURL=base.js.map